/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../../lib/@waca/dashboard-common/dist/api/ContentActionsProviderAPI',
	'underscore'
], function(APIFactory, ContentActionsProviderAPI, _) {

	class EventGroupActions {
		constructor({ features }) {
			if(features) {
				this.dashboard = features.API;
				this._features = features;
			}
		}

		getAPI() {
			if (!this._api) {
				this._api = APIFactory.createAPI(this, [ContentActionsProviderAPI]);
			}
			return this._api;
		}

		_isAvailable(idList) {
			return idList.length && this.dashboard.getMode() === this.dashboard.MODES.EDIT_GROUP && !this._isStaticWidget(idList);
		}

		/**
		 * check if a given selection is a static widget - Static widgets don't have a group
		 * @param {String[]} idList - ids of selected widgets
		 */
		_isStaticWidget(idList) {
			for (let index = 0; index<idList.length; index++) {
				if (!(this._features['EventGroups'].getGroupId(idList[index]))) {
					return true;
				}
			}
			return false;
		}

		/**
		 * Get a count of distinct group indices in the selected nodes
		 * @param {String[]} idList - ids of selected widgets
		 * @return {String[]} distinct group ids in selection
		 */
		_getDistinctGroupIdsInSelection(idList) {
			let distinctGroupIndexesInSelection = _.map(idList, id => {
				return this._features['EventGroups'].getGroupId(id);
			});
			distinctGroupIndexesInSelection = _.uniq(distinctGroupIndexesInSelection);
			return distinctGroupIndexesInSelection;
		}

		/**
		 * Get the page id of a widget
		 * @param {String[]} idList list of widget ids
		 */
		_getPageId(idList) {
			if (idList.length > 0) {
				let content = this.dashboard.getCanvas().getContent(idList[0]);
				while (content && content.getType() !== 'page') {
					content = content.getContainer();
				}
				if (content) {
					return content.getId();
				}
			}
			return false;
		}

		/**
		 * Count groups that will be affected by an action in the current list of selected nodes
		 * @return {Number} count
		 */
		_getCountGroupsAffected(idList) {
			let count = 0;
			let groups = this._features['EventGroups'].getGroupIdsOnPage(this._getPageId(idList));
			if (groups.length > 0 && idList.length > 0){
				count = _.filter(groups, groupId => {
					const groupWidgetIds = this._features['EventGroups'].getContentIdList(groupId);
					return groupWidgetIds.length === _.intersection(groupWidgetIds,idList).length;
				}).length;
			}
			return count;
		}

		/**
		 * Get the number of groups
		 * @return Returns the number of groups or 0 if its a static widget
		 */
		getNumberOfGroups(idList) {
			let pageId = this._getPageId(idList);
			if (!pageId) {
				return 0;
			}

			return this._features['EventGroups'].getGroupIdsOnPage(pageId).length;
		}

	}
	return EventGroupActions;
});
